import { useAuth } from "@/context/AuthContext";
import { hasPermission, type PermissionKey } from "@/lib/permissions";

export function usePermission(key: PermissionKey): boolean {
  const { employee } = useAuth();
  return hasPermission(
    employee?.role,
    employee?.extra_permissions ?? null,
    key,
    employee?.denied_permissions ?? null,
  );
}
